<input class="hiddenInput" bind:files on:change={uploadProfilePicture} bind:this={fileinput} type="file" accept="image/*">

<div class="popup">
    <div on:click={openUploadForm} class="image" style="background-image:url('{$profile.img}');">
        {#if !changingPicture}
            <span>Press to change</span>
        {:else}
            <span><Loading /></span>
        {/if}
    </div>
    <input type="text" on:blur={syncName} bind:value={$profile.name}>

    {#if files && files[0]}
	    <p>{JSON.stringify(files[0])}</p>
    {/if}

    {#if !$userData}
        {#if !authorizing}
            <div>--- or ---</div>
            <button on:click={google}>Log in with Google</button>
        {:else}
            <Loading />
        {/if}
    {:else}

        <hr style="width:100%;" />
        <div>Already loged in with {$userData.provider}</div>
        <div class="image" style="background-image:url('{$userData.providedImage}');"></div>
        {$userData.providedName}

        <button on:click={logout}>Logout</button>

    {/if}

    {#if join.code !== "000000"}
        <button class="leave-room" on:click={leaveRoom}>Pamest esošo istabu</button>
    {/if}

    <CloseButton on:click={() => showProfile.set(false)} />
</div>

<style>
.popup{
    position: absolute;
    max-width: 600px;
    background-color: #afa849;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 30px;
}
.leave-room {
    margin-top: 20px;
    padding: 20px;
}
.hiddenInput{ display: none; }
input{ 
    border-radius: 5px;
    padding: 10px;
    border: 1px solid yellow;
}
.image{
    width: 100px;
    height: 100px;
    background-size: contain;
    background-position: 50% 50%;
    border-radius: 50%;
    border: 3px solid #cdcdcd;
    background-color: #fff;
    cursor: pointer;
}
.image > span {
    text-align: center;
    color: white;
    font-weight: 200;
    display: flex;
    align-items: center;
    height: 100%;
    border-radius: 50%;
    background-color: #00000088;
}
.image > span:hover {
    background-color: #00000000;
    color: transparent;
}
</style>

<script>
import { showProfile, userData } from "../stores/index"
import { profile } from "../stores/profile"
import { join, restartDefault } from "../stores/join"
import CloseButton from "../components/buttons/Close.svelte"
import Loading from "../layout/Loading.svelte"

let fileinput // binding hidden input
let files // bind upload files
let authorizing = false
let changingPicture = false

export let socket

const openUploadForm = () => {
    fileinput.click()
}

const uploadProfilePicture = async () => {
    if (!files || !files[0]) return;
    const file = files[0]

    changingPicture = true

    const form = new FormData()
    const token = localStorage.getItem('token')

    form.append('picture', file)
    form.append('token', token)

    const upload = await fetch('/upload-profile-picture', {
        method: 'PUT',
        body: form
    }).then(res => res.json())
    
    if (upload.success) {
        changingPicture = false
        profile.set( {
            ...$profile,
            img: upload.link
        } )
    }    
}

const google = async () => {    
    const provider = new firebase.auth.GoogleAuthProvider()
    const { user, token, idToken } = await firebase.auth().signInWithPopup(provider).then( res => ({
        user: res.user
    }) ).catch( e => false )

    if (user) {
        authorizing = true
        const token = await firebase.auth().currentUser.getIdToken()
        socket.emit('auth-google', user.uid, token )
    }
}

const logout = async () => {
    socket.emit('logout')
}

const syncName = () => {
    socket.emit('changeName', $profile.name)
}

const leaveRoom = () => {
    socket.emit("leaveRoom")
    restartDefault()
    showProfile.set(false)
}
</script>